import { ApiService } from '../../services'
export const UserModule = {
    namespaced: true,
    state : {
        endpoint : 'user',
    },
    actions : {

        async checkToken(_,token) {
            return await new Promise((resolve, reject) => {
                ApiService.getToken(token).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        async authToken(_,token) {
            return await new Promise((resolve, reject) => {
                ApiService.getToken(token).then((response) => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    },
   
}


